module.exports = __webpack_public_path__ + "img/model-content-back.c4459963.png";